import { InsuranceCompany, InsuranceCompanyDetails } from '../../resources/insurance';
import { restClient } from '../../client';
import snakecaseKeys from 'snakecase-keys';


export type GetInsuranceCompaniesInput = {
  onlyAvailable?: boolean;
  stateId?: string;
};

export const getInsuranceCompanies = ({ onlyAvailable = true, stateId }: GetInsuranceCompaniesInput) =>
  restClient.request<{ data: InsuranceCompany[] }>(
    '/api/v1/insurance/companies',
    {
      method: 'GET',
      params: snakecaseKeys({ onlyAvailable, stateId })
    });


export const createInsuranceCompany = (data: {
  name: InsuranceCompany['name'];
  url: InsuranceCompany['url'];
  logoUrl: InsuranceCompany['logoUrl'];
  groupName?: InsuranceCompany['groupName'];
  shortName?: InsuranceCompany['shortName'];
  payerEmails?: string[];
  order?: InsuranceCompany['order'];
  key?: InsuranceCompany['key'];
  payorId?: InsuranceCompany['payorId'];
  metaGrouping: InsuranceCompany['metaGrouping'];
  delegated?: InsuranceCompany['delegated'];
  available?: InsuranceCompany['available'];
  stateIds?: string[];
  unsupportedInsuranceCodes?: string[];
}) =>
  restClient.request<{ data: InsuranceCompany[] }>(
    '/api/v1/insurance/companies',
    {
      method: 'POST',
      data: snakecaseKeys(data)
    });


export type UpdateInsuranceCompanyInput = {
  groupName?: InsuranceCompany['groupName'];
  available?: InsuranceCompany['available'];
  delegated?: InsuranceCompany['delegated'];
  shortName?: InsuranceCompany['shortName'];
  unsupportedInsuranceCodes?: InsuranceCompanyDetails['unsupportedInsuranceCodes'];
  payerEmails?: InsuranceCompanyDetails['payerEmails'];
  stateIds?: string[];

  // super admin fields
  payorId?: InsuranceCompany['payorId'];
  name?: InsuranceCompany['name'];
  key?: InsuranceCompany['key'];
  url?: InsuranceCompany['url'];
  logoUrl?: InsuranceCompany['logoUrl'];
  order?: InsuranceCompany['order'];
  metaGrouping?: InsuranceCompany['metaGrouping'];
};

export const updateInsuranceCompany = (
  companyId: string,
  data: UpdateInsuranceCompanyInput,
) => restClient.request<{ data: InsuranceCompany[] }>(`/api/v1/insurance/companies/${companyId}`, {
  method: 'POST',
  data: snakecaseKeys(data)
});


export const deleteInsuranceCompany = (companyId: string) => restClient.request(`/api/v1/insurance/companies/${companyId}`, {
  method: 'DELETE'
});


export const getInsuranceCompaniesStates = () =>
  restClient.rawRequest<{ data: Record<string, string[]> }>('/api/v1/insurance/companies-states');


export const getInsuranceCompaniesDetails = () =>
  restClient.request<{ data: InsuranceCompanyDetails[] }>('/api/v1/insurance/companies-details');
